import { useCallback } from "react";
import { debounce } from "lodash";

import { useFeatures } from "components/FeatureFlag";

export function useDebouncedSave(saveDraft, setDraftGid) {
  const flag = useFeatures("autosaving-comments-config");

  return useCallback(
    debounce(
      (value, draftGid, taskUuid, clientWorkflowUuid, isLoading) => {
        if (isLoading) {
          return;
        }
        saveDraft(value, draftGid, taskUuid, clientWorkflowUuid).then(
          (result) => {
            if (result?.data?.draftGid) {
              setDraftGid(result.data.draftGid);
            }
          }
        );
      },
      flag?.wait || 4000,
      { maxWait: flag?.maxWait || 10000 }
    ),
    []
  );
}

export default useDebouncedSave;
